import 'css-chunksrc/client/common/secondaryCriteriaForm/documentForm/directoryStructure/loader/styles.scss';export default {
  "folder": "_folder_15tpd_1",
  "document": "_document_15tpd_13",
  "folderIcon": "_folderIcon_15tpd_28",
  "documentIcon": "_documentIcon_15tpd_35"
};